import api from '@synergycms_core/utils/api';
import ParamsParser from '@synergycms_core/utils/paramsParser';
import { fromJS, List, Map } from 'immutable';
import moment from 'moment';
import { reduce, contains, any, pipe, range, append, uniq } from 'ramda';
import actions from './../actions';
import { parseAvail } from './availUtils';

/*"date"           => $fromDate->format('Y-m-d'),
  "stay_length"    => $stayLength,
  "checkin_days"   => $checkinDays,
  "occups"         => self::ADULT_TYPE_ID.":$adults".($childs ? ",".self::CHILD_TYPE_ID.":$childs" : ""),
  "country"        => $country,
  "source"         => "wg", // TODO
  "channel"        => $channel,
  "refundability"  => "all",
  "daily_details"  => true,
  //"promotion_code" => !empty($promoCode) ? $refererCode : null,
  //"referer_code"   => !empty($referer) ? $refererCode : null,
  //"company_id"     => $companyId,
  "avail_code"    => $refererCode,
  "room_id"       => $roomID,
  "board_id"       => $boardID,
  "rate_id"       => $rateID*/

//api/hotels/82/availability/rooms?
//channel=Web
//checkin_days=14
//daily_details=true
//date=2018-10-23
//ignore_night_discounts=true
//occup_groups=4
//refundability=all
//rooms=23
//rooms=24
//rooms=25
//stay_length=1



export default {
  REFRESH: refresh => refresh,
  SET_REQUESTED: (hotelID, stringHotelSearchParams, range) => {
    return (dispatch, getStore) => {
      var store = getStore();
      const availObj = Map({
        raw_response: store.getIn(['availCalendar', hotelID, stringHotelSearchParams, 'raw_response'], List()).concat(range),
        response: Map({ requested: true })
      });

      return Map([[hotelID, Map([[stringHotelSearchParams, availObj]])]]);
    }
  },
  GET_ASYNC: (start, end, override) => {
    return (dispatch, getStore) => {
      const store = getStore();
      override = override && override.filter((val) => val);
      
      const corporateStore = store.getIn(['customer', 'corporate']) || Map();
      const companyCode = corporateStore.get('afiliado', false) || corporateStore.get('avail_code', false) || false;

      const hotelID = (override && override.get("hotels")) || store.getIn(['customer', 'current_hotel']);
      const hotelState = store.getIn(['hotels', store.getIn(['customer', 'current_hotel'])], Map());

      const params = hotelState.getIn(['params', store.getIn(["availQuery", "mono", "params"])], false);

      if (params) {
        let hotelSearchParams = hotelState.getIn(["params", store.getIn(["availQuery", "mono", "params_calendar"])]);
        let stringHotelSearchParams;

        
        if(override && override.size) {
          const calendarParams = hotelState.getIn(["params", store.getIn(["availQuery", "mono", "base_params_calendar"])]);
          hotelSearchParams = calendarParams.merge(override);
          stringHotelSearchParams = ParamsParser.paramsToQuery(hotelSearchParams);
        } else {
          hotelSearchParams = hotelState.getIn(["params", store.getIn(["availQuery", "mono", "params_calendar"])]);
          stringHotelSearchParams = hotelState.getIn(["params", store.getIn(["availQuery", "mono", "string_calendar"])]);
        }

        
        let currentAvail = store.getIn(['availCalendar', hotelID, stringHotelSearchParams, 'raw_response'], List());
        if (params.get('stay_length') >= 30) {
          const availObj = Map({
            raw_response: List(),
            response: Map()
          });

          return Map([[hotelID, Map([[stringHotelSearchParams, availObj]])]]);
        }


        
        let days = !currentAvail.get('requested') ? currentAvail.map(day => day.get('checkin')) : List();

        
        let newDate = null;
        let defaultNumberOfResults = 15;
        if (start && end) {
          const rangeList = [];
          let rangeRequested = List();
          let current = moment(start) < moment() ? moment() : moment(start);
          while (current <= end) {
            let date = current.format("YYYY-MM-DD");
            if (!currentAvail.find((item) => item.get("checkin") === date)) {
              rangeList.push(date);
              rangeRequested = rangeRequested.push(Map({checkin:date}));
            }
            current.add(1, "day");
          }

          newDate = moment(rangeList[0]);
          defaultNumberOfResults = rangeList.length;

          dispatch(actions.availCalendar.setRequested(hotelID, stringHotelSearchParams, rangeRequested));
        }


        const currentRange = pipe(
          range(0),
          reduce(
            (dateRange, date) =>
              append(
                moment(newDate)
                  .add(date, 'days')
                  .format('YYYY-MM-DD'),
                dateRange
              ),
            []
          )
        )(defaultNumberOfResults);

        //si no te tots els dies demanem de nou les dades
        //TODO es podria millorar per demanar varis ranges
        if (hotelSearchParams && (any(day => !contains(day, days))(currentRange))) {
          let newParams = hotelSearchParams.set('date', moment(newDate).format('YYYY-MM-DD'));
          if (companyCode) {
            newParams = newParams.set('avail_code', companyCode);
          }

          newParams = newParams.set("checkin_days", defaultNumberOfResults);
          const queryParams = ParamsParser.paramsToQuery(newParams);
          return api
            .get('availability', {
              q: queryParams + ',hotels:' + hotelID
            })
            .then(response => {
              currentAvail = getStore().getIn(['availCalendar', hotelID, stringHotelSearchParams, 'raw_response'], List());
              days = currentAvail.map(day => day.get('checkin'));
              const newAvail =
                !response[hotelID] || response[hotelID].success === false ? List() : fromJS(response[hotelID]);
              let rawResponse = List();

                uniq(days.toJS().concat(currentRange))
                .sort()
                .forEach(day => {
                  const newDay = newAvail.find(avail => avail.get('checkin', null) === day);
                  if (!newDay) {
                    const oldDay = currentAvail.find(avail => avail.get('checkin', null) === day);
                    if (oldDay) {
                      rawResponse = rawResponse.push(oldDay);
                    } else {
                      rawResponse = rawResponse.push(Map({ checkin: day }));
                    }
                  } else {
                    rawResponse = rawResponse.push(newDay);
                  }
                });
              /*.groupBy(day => day.get("checkin"))
              .map(day => day.first())
              .toList().sortBy(day => day.get("checkin"));/*/

              const hotelAvailData = store.getIn(['availCalendar', hotelID, stringHotelSearchParams], List());
              const availObj = Map({
                raw_response: rawResponse,
                response: parseAvail(
                  rawResponse,
                  hotelAvailData.get('minPrice'),
                  hotelAvailData.get('maxPrice'),
                  hotelAvailData.get('freeBreakFast'),
                  hotelState.get("show_taxes", true)
                )
              });

              return Map([[hotelID, Map([[stringHotelSearchParams, availObj]])]]);
            })
            .catch(error => {
              console.log(error);
              return Promise.resolve(List());
            });
        }
      }
      return Promise.resolve();
    };
  }
};
